export type TextDirection = 'ltr' | 'rtl';

export function getPersistedTextDirection(html: string | object | null | undefined): TextDirection | null {
  if (!html || typeof html !== 'string') return null;
  // Legacy CKEditor-saved reports wrapped content in
  //   <div data-clipr-text-direction="rtl" dir="rtl" style="…">
  const legacy = html.match(/data-clipr-text-direction="(ltr|rtl)"/);
  if (legacy) return legacy[1] as TextDirection;
  // Modern format: dir attr on the first block-level element. Match any of
  // p / h1-6 / ul / ol / li / blockquote / table / td / th so legacy reports
  // whose first content is inside a list or table still get detected.
  const block = html.match(/<(?:p|h[1-6]|ul|ol|li|blockquote|table|td|th)[^>]*\bdir="(ltr|rtl)"/i);
  return block ? (block[1] as TextDirection) : null;
}
